<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="学校名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入学校名称" />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type" >
        <a-select placeholder="请选择类型" v-model="form.type">
          <a-select-option value="1">小学</a-select-option>
          <a-select-option value="2">初中</a-select-option>
          <a-select-option value="3">高中</a-select-option>
          <a-select-option value="4">大学</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="地址省" prop="provinceName" >-->
<!--        <a-input v-model="form.provinceName" placeholder="请输入地址省" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="地址市" prop="cityName" >-->
<!--        <a-input v-model="form.cityName" placeholder="请输入地址市" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="地址区" prop="countyName" >-->
<!--        <a-input v-model="form.countyName" placeholder="请输入地址区" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="市区" prop="cityId" >
        <a-select placeholder="请选择市区" v-model="form.cityId" optionFilterProp="label" show-search style="width: 100%" allow-clear>
          <a-select-option v-for="(d, index) in cityList" :key="index" :label="d.name" :value="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="详细地址" prop="detailedAddress" >
        <a-input v-model="form.detailedAddress" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-item-->
<!--        label="地图选点">-->
<!--        <div id="app">-->
<!--          <MapSelect @location-selected="handleLngLatSelect" :initialLngLat="lngLatMap"/>-->
<!--        </div>-->
<!--      </a-form-item>-->

<!--      <a-form-model-item label="地址经度" prop="longitude" >-->
<!--        <a-input v-model="form.longitude" placeholder="请输入地址经度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="地址维度" prop="dimensionality" >-->
<!--        <a-input v-model="form.dimensionality" placeholder="请输入地址维度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSchool, addSchool, updateSchool } from '@/api/platform/school'
import MapSelect from './MapSelect.vue';
import {listArea} from "@/api/platform/area";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    MapSelect
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      lngLatMap: {},
      cityList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // 表单参数
      form: {
        id: null,

        name: null,

        type: null,

        provinceName: null,

        cityId: null,

        cityName: null,

        countyName: null,

        detailedAddress: null,

        longitude: null,

        dimensionality: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
    this.cityInit();
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // filterCityOption(input, option) {
    //   console.log("过滤城市:", input, option);
    //   const cityName = option.children().props.d.name;
    //   return cityName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    // },
    cityInit(){
      listArea({"level":2}).then(response => {
        this.cityList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        type: null,
        provinceName: null,
        cityName: null,
        countyName: null,
        detailedAddress: null,
        longitude: null,
        dimensionality: null,
        createTime: null,
        remark: null,
      }
    },
    handleLngLatSelect(lnglat) {
      console.log("选中的经纬度222:", lnglat);
      this.form.longitude = lnglat.lng;
      this.form.dimensionality = lnglat.lat;

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSchool({"id":id}).then(response => {
        this.form = response.data
        this.form.type = response.data.type + "";
        // this.lngLatMap = {
        //   lng: response.data.longitude,
        //   lat: response.data.dimensionality
        // }

        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSchool(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSchool(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
